import { useRecoilState } from 'recoil';

import { userSettingsState } from '@store';

import { UserLocation } from '../constants/types/userSettings';

/**
 * useGetUserLocation: an intermediary hook to pull location data out of recoil
 * Slightly cleaner to use this than having to use recoil in every place it's needed
 * defaultAndWatching: returns an array with the watching & default locations if are different
 * otherwise returns one item.
 */
export function useGetUserLocation<T extends boolean | undefined = undefined>(
  useUserDefault?: boolean,
  defaultAndWatching?: T,
): T extends true ? UserLocation[] : UserLocation | undefined;
export function useGetUserLocation(useUserDefault = false, defaultAndWatching = false) {
  const [userSettings] = useRecoilState(userSettingsState);

  if (defaultAndWatching) {
    const locations = userSettings.locations.filter(item => item.isDefault || item.isWatching);

    // Move location watching at the first position
    locations.unshift(
      locations.splice(
        locations.findIndex(item => item.isWatching),
        1,
      )[0],
    );

    return locations;
  }

  return userSettings.locations.find(item => (useUserDefault ? item.isDefault : item.isWatching));
}
